import { produce } from 'immer';
import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { CONDITION_ACTION_TYPE } from '../actions';

const initialState = {};

const conditionsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CONDITION_ACTION_TYPE.GET_CONDITIONS:
        return payload || state;

      case CONDITION_ACTION_TYPE.GET_CONDITION:
      case CONDITION_ACTION_TYPE.ADD_CONDITION:
      case CONDITION_ACTION_TYPE.UPDATE_CONDITION:
        draft[payload.id] = payload;
        break;

      case CONDITION_ACTION_TYPE.DELETE_CONDITION:
        delete draft[payload];
        break;

      case CONDITION_ACTION_TYPE.REORDER_CONDITIONS: {
        const sortedData = _.sortBy(draft, ({ id }) => payload.indexOf(id));

        return sortedData.reduce((acc, condition) => {
          acc[condition.id] = condition;

          return acc;
        }, {});
      }

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default conditionsReducer;
